import { FilterModel } from "@app/models/customer-transaction-history/Transaction-Filter-model";

export class AcquirerModel {
    TotalSale: number;
    TotalSettlementAmount: number;
    WalletSale: number;
    CreditDebit: number;
    PrePaid: number;
    VAS: number;
    UnSettledAmount: number;
}

export class AcquirerOutlet {
    OutletId: string;
    MerchantId : number;
    MerchantCode: number;
    OutletName: string;
    OutletCode: number;
    Location: string;
    OutletType: string;
    OutletCategory: string;
    ExternalId: string;
    StatusTypeId: number;
    MerchantName: string;
    GeoLat: string;
    SubCategoryTypeId: number;
    GeoLong: string;
    GeoAlt: string;
    Status: string;
    OutletStatus: string;
    Count: number;
    LoggedInUser: number;
    SkipCount: number;
    filterModel=new FilterModel();
    constructor() {
        //this.MerchantCode;
        this.OutletName = '';
        //this.OutletCode;
        this.ExternalId = '';
        this.Location = '';
        //this.LoggedInUser = 0;
    }
}

export class SearchOutletPagingModel {
    Txndetails: AcquirerOutlet[];
    TotalCount: number;
}

export class AcquirerTerminal {
    OutletId: number;
    TerminalNumber: number;
    TerminalTypeId
    AcquirerName: string;
    MerchantCode: string;
    OutletName: string;
    SerialNo: string;
    TerminalType: string;
    ExternalId: string;
    Status: string;
    MerchantName: string;
    OutledCode: number;
    InstitutionName: string;
}

export class AcquirerTerminals {
    AcquirerTerminalList: AcquirerTerminal[];
    TotalRecords: number;
}


// WEBPACK FOOTER //
// ./src/app/models/merchant/AcquirerModel.ts